import axios from "axios";
import { Constant } from "../../../config/index";

export default {
  _getConfigurationList: async (key) => {
    const url = `${Constant.BASE_API}/configuration/${key}`;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  },
  _getWhitelistURList: async (id, page, limit, memberID) => {
    let url = `${Constant.BASE_API}/whitelist-url/list/${id}?page=${page}&limit=${limit}`;
    if (memberID > 0) {
      url += `&member_id=${memberID}`;
    }

    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data;
  },
  _deleteWhitelistURL: async (memberConfigID) => {
    const url = `${Constant.BASE_API}/whitelist-url/delete/${memberConfigID}`;
    const opt = {
      url,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      throw resp.data.error;
    }

    return { error: false };
  },
  _updateWhitelistURL: async (memberConfigID, payload) => {
    const url = `${Constant.BASE_API}/whitelist-url/update/${memberConfigID}`;
    const opt = {
      url,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      throw resp.data.error;
    }

    return { error: false };
  },
  _createWhitelistURL: async (configID, payload) => {
    const url = `${Constant.BASE_API}/whitelist-url/add/${configID}`;
    const opt = {
      url,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      throw resp.data.error;
    }

    return { error: false };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Keyword/WhitelistURL/service.js